import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const JourneySection = styled(Box)(({ theme }) => ({
  margin: '0 auto',
  maxWidth: '1300px',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const JourneyContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
}));

export const JourneyTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontFamily: theme.typography.fontFamily.quicksand,
  fontSize: '22px',
  fontWeight: 600,
  letterSpacing: '.4px',
  margin: '0 auto 20px',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    margin: '0 auto 16px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    margin: '0 auto 14px',
  },
}));

export const JourneyCardsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: theme.spacing(18.75),
  alignItems: 'center',
  transform: 'scale(0.4)',
  overflowX: 'auto',
  padding: theme.spacing(0, 1, 1),
  scrollBehavior: 'smooth',
  WebkitOverflowScrolling: 'touch',
  justifyContent: 'flex-start',
  marginTop: '15px',
  [theme.breakpoints.up('sm')]: {
    gridAutoColumns: theme.spacing(20),
  },
  [theme.breakpoints.up('md')]: {
    gridAutoColumns: '202px',
    transform: 'scale(1)',
    overflowX: 'visible',
    padding: 0,
    justifyContent: 'center',
    margin: '0 auto',
  },
  '& > *': {
    minWidth: theme.spacing(18.75),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(20),
    },
    [theme.breakpoints.up('md')]: {
      minWidth: theme.spacing(21.25),
    },
  },
  '&::-webkit-scrollbar': {
    height: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.18)',
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
}));

export const JourneyButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: '77px auto 0',
  height: '60px',
  [theme.breakpoints.down('md')]: {
    margin: '50px auto 0',
    height: '56px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '36px auto 0',
    height: '52px',
  },
}));
